function addNostoCarousel(divId) {
  console.log('Entra al parent')
  const container = document.getElementById(divId);
  const elementsContainer = container.querySelector(".nosto-carousel") || container.querySelector(".nosto-list");
  const elements = elementsContainer.children
  console.log('Elements')
  console.log(elements)
  for (const element of elements) {
    console.log('Elemento card creación')
    new Card(element.dataset.productId, element.id, "carousel", container.dataset.nostoSlotId, container);
  }
  if (container.parentElement.querySelector(".carousel-title")) {
    container.querySelector(".title").remove();
  }
  container.classList.remove("hidden");
}